var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineStore } from 'pinia';
import api from '../modules/axios';
import { useAuthorizationStore } from './authorization';
import { useAuthStore } from './auth';
export var useProfileStore = defineStore('profile', {
    state: function () { return ({
        id: null,
        customer_id: null,
        name: null,
        avatar: null,
        type: null,
        /*
        point: {
          engate_points: 0,
          sum_engate_points: 0,
          sum_limited_points: 0,
          sum_target_points: 0,
          limited_points: [],
          target_points: []
        }, */
        community: {},
        engate_id: null,
        email: null,
    }); },
    getters: {
        findAvatar: function (state) {
            return state.avatar;
        },
        hasProfileStore: function (state) {
            return !!state.engate_id;
        },
    },
    actions: {
        setUserProfile: function () {
            return __awaiter(this, void 0, void 0, function () {
                var auth, token, result, avatar, imgPath, imgSrc, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            auth = useAuthStore();
                            token = sessionStorage.getItem('tkn');
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, api.get('/user/profile', {
                                    headers: {
                                        'Authorization': "Bearer ".concat(String(token)),
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            if (result.data.user.confirmed_at !== null) {
                                avatar = String(result.data.user.avatar);
                                imgPath = (window.location.hostname === 'media.engate.jp') ? 'https://engate.jp' : 'https://engate.site';
                                imgSrc = avatar.startsWith('https://engate.') ? avatar : "".concat(imgPath).concat(avatar);
                                Object.assign(this.$state, {
                                    id: result.data.user.id,
                                    customer_id: result.data.user.customer_id,
                                    name: result.data.user.name,
                                    avatar: imgSrc,
                                    type: result.data.user.type,
                                    engate_id: result.data.user.engate_id,
                                    email: result.data.user.email,
                                });
                            }
                            auth.setConfirmUser(!!result.data.user.confirmed_at);
                            return [2 /*return*/, result];
                        case 3:
                            err_1 = _a.sent();
                            return [2 /*return*/, err_1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        resetUserProfile: function () {
            Object.assign(this.$state, {
                id: null,
                customer_id: null,
                name: null,
                avatar: null,
                type: null,
                /*
                point: {
                  engate_points: 0,
                  sum_engate_points: 0,
                  sum_limited_points: 0,
                  sum_target_points: 0,
                  limited_points: [],
                  target_points: []
                }, */
                community: {},
                engate_id: null,
                email: null,
            });
        },
        resetPassword: function (email) {
            return __awaiter(this, void 0, void 0, function () {
                var result, err_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, api.post('/password/forgot', { email: email })];
                        case 1:
                            result = _a.sent();
                            return [2 /*return*/, result];
                        case 2:
                            err_2 = _a.sent();
                            return [2 /*return*/, err_2];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        setNewPassword: function (payload) {
            return __awaiter(this, void 0, void 0, function () {
                var result, err_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, api.post('/password/reset', {
                                    password: payload.password,
                                    customer_id: payload.cid,
                                }, {
                                    headers: {
                                        'reset-password-token': payload.token
                                    }
                                })];
                        case 1:
                            result = _a.sent();
                            return [2 /*return*/, result];
                        case 2:
                            err_3 = _a.sent();
                            return [2 /*return*/, err_3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        oauthConfirmation: function (payload) {
            return __awaiter(this, void 0, void 0, function () {
                var authorize, result, err_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            authorize = useAuthorizationStore();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, api.post('/user/profile', payload, {
                                    headers: {
                                        'Authorization': "Bearer ".concat(String(authorize.authToken)),
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            return [2 /*return*/, result];
                        case 3:
                            err_4 = _a.sent();
                            return [2 /*return*/, err_4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
    },
    persist: true,
});
